module.exports = __webpack_public_path__ + "media/dashboard/assets/images/convergence_logo_log-85bffc0b86da7671c31bf542a04c6083.png";